//ecd:492059792H20261022084009_V3.0
/**
 * CreditCardType
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
export const CreditCardType = {
    VISA: "VISA",
    MASTER_CARD: "MAST",
    AMERICAN_EXPRESS: "AMEX"
} as const;

export type CreditCardType = typeof CreditCardType[keyof typeof CreditCardType];


/** The constant a wire value stands for, or undefined. */
export function creditCardTypeOf(value: string | null | undefined): CreditCardType | undefined{
    if (value == null) return undefined;
    return Object.values(CreditCardType).find((v) => v === value) as CreditCardType | undefined;
}

/** What a screen shows for each value. */
export const CreditCardTypeLabel: Record<CreditCardType, string> = {
    [CreditCardType.VISA]: "Visa",
    [CreditCardType.MASTER_CARD]: "Master Card",
    [CreditCardType.AMERICAN_EXPRESS]: "American Express",
};
